import qs from "qs";
import {
    ID_FILTER_RECHARGE_DEALERS,
    ID_FILTER_RECHARGE_LEGAL_ENTITIES,
    ID_FILTER_RECHARGE_CUSTOMER,
    ID_FILTER_RECHARGE_PLACE,
    ID_FILTER_RECHARGE_RFID,
    ID_FILTER_RECHARGE_STATIONTYPE,
    ID_FILTER_RECHARGE_STATUSES,
    ID_FILTER_SEARCH
} from "../../pages/enelx/constants/EnelxFilters";
import { FilterDef, HTTPGenericResponse } from "../../constants/FinanceModels";
import { getFilterValue } from "../../utils/FilterUtils";
import { useApi } from "../Api";
import { useContext } from "react";
import { GlobalContext } from "../../../../util/state/GlobalContextProvider";

export const useRechargeRepository = () => {
    const { GET, PUT } = useApi();

    const PATH = "/finance/enel-x/recharges"
    
    const {  globalData: { user } } = useContext(GlobalContext);
    const allLegalEntities: any[] = user.legalEntities?.filter((x: any) => x.name.toLowerCase() !== "all").map((x: any) => x.name);
   
    function getRecharges(offset: number, limit: number, sort: string | null, order: string | null, filterDefs: FilterDef[] = []): Promise<HTTPGenericResponse> {
        let search = getFilterValue(ID_FILTER_SEARCH, filterDefs);
        let customer = getFilterValue(ID_FILTER_RECHARGE_CUSTOMER, filterDefs);
        let rfid = getFilterValue(ID_FILTER_RECHARGE_RFID, filterDefs);
        let place = getFilterValue(ID_FILTER_RECHARGE_PLACE, filterDefs);
        let stationType = getFilterValue(ID_FILTER_RECHARGE_STATIONTYPE, filterDefs);
        let status = getFilterValue(ID_FILTER_RECHARGE_STATUSES, filterDefs);
        let legalEntities: string[] = getFilterValue(ID_FILTER_RECHARGE_LEGAL_ENTITIES, filterDefs) || allLegalEntities;
        let dealers: string[] = getFilterValue(ID_FILTER_RECHARGE_DEALERS, filterDefs);

        let params = {
            offset: offset,
            limit: limit,
            sort: sort,
            order: order,
            search: search,
            customerName: customer,
            rfid: rfid,
            place: place,
            stationType: stationType,
            status: status,
            legalEntities,
            dealers
        }

        return GET(`${PATH}/all`, { params: params, paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }) });
    }

    function getRechargesByReport(reportId: string, offset: number, limit: number, sort: string | null, order: string | null): Promise<HTTPGenericResponse> {
        let params = {
            offset: offset,
            limit: limit,
            sort: sort,
            order: order,
            reportId: reportId,
            legalEntities: allLegalEntities, // reportId garantisce che vengano recuperate solo le ricariche legate a quello specifico report
            dealers: []
        }

        return GET(`${PATH}/all`, { params: params, paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }) }, true);
    }

    function getSummary(filterDefs: FilterDef[] = []): Promise<HTTPGenericResponse> {
        let search = getFilterValue(ID_FILTER_SEARCH, filterDefs);
        let customer = getFilterValue(ID_FILTER_RECHARGE_CUSTOMER, filterDefs);
        let rfid = getFilterValue(ID_FILTER_RECHARGE_RFID, filterDefs);
        let place = getFilterValue(ID_FILTER_RECHARGE_PLACE, filterDefs);
        let stationType = getFilterValue(ID_FILTER_RECHARGE_STATIONTYPE, filterDefs);
        let status = getFilterValue(ID_FILTER_RECHARGE_STATUSES, filterDefs);
        let legalEntities: string[] = getFilterValue(ID_FILTER_RECHARGE_LEGAL_ENTITIES, filterDefs) || allLegalEntities;
        let dealers: string[] = getFilterValue(ID_FILTER_RECHARGE_DEALERS, filterDefs);

        let params = {
            search: search,
            customerName: customer,
            rfid: rfid,
            place: place,
            stationType: stationType,
            status: status,
            legalEntities,
            dealers
        }

        return GET(`${PATH}/all-status-summary`, { params: params, paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }) });
    }

    function getPlaces(search: string): Promise<HTTPGenericResponse> {
        let params = {
            search: search,
            limit: 10
        }
        return GET(`${PATH}/places`, { params: params });
    }


    function validateRecharges(ids: string[]): Promise<HTTPGenericResponse> {
        return PUT(`${PATH}/validate`, ids, {}, true);
    }


    return { getRecharges, getRechargesByReport, getSummary, getPlaces, validateRecharges };
}